<template>
  <div id="app">
    <AppHeader></AppHeader>
    <AppNavigation></AppNavigation>
    <main>
      <router-view/>
    </main>
    <AppFooter></AppFooter>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import AppNavigation from '@/components/AppNavigation.vue';
import AppFooter from '@/components/AppFooter.vue';

export default {
  name: 'app',
  components: {
    AppHeader,
    AppNavigation,
    AppFooter,
  },
  // mounted() {
  //   this.$Progress.finish();
  // },
  // created () {
  //   this.$Progress.start();
  //   this.$router.beforeEach((to, from, next) => {
  //     if (to.meta.progress !== undefined) {
  //       let meta = to.meta.progress;
  //       this.$Progress.parseMeta(meta);
  //     }
  //     this.$Progress.start();
  //     next()
  //   })
  //   this.$router.afterEach((to, from) => {
  //     this.$Progress.finish();
  //   })
  // }
}
</script>
